import initSliders from "./components/slider.js";
import initInputs, {forceHTML5Validation} from "./components/inputs.js";
import initHeader from "./header/header";
import initAnimations from "./components/animations.js";
import "fslightbox";

initHeader();
initSliders();
initInputs();
forceHTML5Validation();
initAnimations();
